export const ApaRefenceStyles = () => {
    return {
        "& .chartFooter__bibliographicReferences": {
            marginTop: "10px"
        },

        "& .apaReference.accordion .cardHeader": {
            padding: "10px"
        },

        "& .apaReference.accordion .cardHeader button": {
            fontSize: "120px"
        },

        "& .apaReference.accordion .cardBody": {
            padding: "10px"
        }
    }
}
